const { LAYOUT_TABS, SYSTEM_STATUS_TABS_TYPES } = require('./consts');

exports.SAAS_SUPPORT_USER_GUID = 'SilverfortSupportUser';

exports.SYSTEM_MODES = {
    ON_PREM: 1,
    SAAS: 2,
    SAAS_SUPPORT: 3
};

exports.SYSTEM_MODE_HIDDEN_SYSLOG_FIELDS = {
    [this.SYSTEM_MODES.ON_PREM]: new Set([]),
    [this.SYSTEM_MODES.SAAS]: new Set([
        'RADIUSClients',
        'License',
        'NodesConfigurations',
        'PushServicesNodesConfigurations',
        'PushServicesLogLevel',
        'NodeLogLevel',
        'LogLevel',
        'PushServicesEnabled',
        'SaasPushServicesEnabled',
        'OverwriteAryaLogo',
        'PushServicesExternalIntegrationEnabled',
        'PushServicesExternalIntegrationApiKey',
        'PushServicesSecondaryUrl',
        'DesktopMFAClientSecret',
        'ShowOtpOnAutoPairedDevice',
        'OtpNotificationIcon',
        'OtpNotificationBackground1',
        'OtpNotificationBackground2',
        'ShowOtpNotificationIcon',
        'OtpNotificationHeight',
        'OtpNotificationWidth',
        'CustomOtpNotification',
        'OtpNotificationInCenterPosition'
    ])
};

exports.SYSTEM_MODE_HIDDEN_VIEWS = {
    [LAYOUT_TABS.SYSTEM_STATUS.ID]: {
        /*
            selectedTab: default tab per system mode
            hiddenTabs: tabs to hide
            hideLogActions: completely hide log actions view
        */
        [this.SYSTEM_MODES.ON_PREM]: {
            selectedTab: SYSTEM_STATUS_TABS_TYPES.NODES,
            hiddenTabs: new Set([SYSTEM_STATUS_TABS_TYPES.AD_CONNECT]),
            hideLogActions: false
        },
        [this.SYSTEM_MODES.SAAS]: {
            selectedTab: SYSTEM_STATUS_TABS_TYPES.DCS,
            hiddenTabs: new Set([
                SYSTEM_STATUS_TABS_TYPES.NODES,
                SYSTEM_STATUS_TABS_TYPES.PUSH_SERVICES,
                SYSTEM_STATUS_TABS_TYPES.ADMIN_CONSOLE
            ]),
            hideSystemBackup: true,
            hideLogActions: true
        },
        [this.SYSTEM_MODES.SAAS_SUPPORT]: {
            selectedTab: SYSTEM_STATUS_TABS_TYPES.NODES,
            hiddenTabs: new Set([SYSTEM_STATUS_TABS_TYPES.PUSH_SERVICES]),
            hideSystemBackup: true,
            hideLogActions: false
        }
    },
    [LAYOUT_TABS.SYSTEM_SETUP.ID]: {
        /*
            tabs: the category inner tabs to hide
            fields: specific fields inside the tabs to hide
            terms: field/tab/category names to remove form settings search bar
        */
        [this.SYSTEM_MODES.ON_PREM]: {
            tabs: new Set(),
            fields: new Set(['silverfortSupportEnabled', 'silverfortSupport']),
            terms: new Set(['Enable Silverfort Support', 'Silverfort Support'])
        },
        [this.SYSTEM_MODES.SAAS]: {
            tabs: new Set([
                'radiusClients',
                'adfsFederatedApps',
                'pingFederatedApps',
                'advancedConfig',
                'elasticConfig',
                'syslogServers',
                'adfsAndMfa',
                'mobileMessagingServices'
            ]),
            fields: new Set([
                'APIcertificate',
                'APIcertificateRequest',
                'backupLdapIp',
                'backupUseSecureLdap',
                'domainId',
                'isNew',
                'ldapDomainName',
                'ldapIp',
                'rootCAcertificate',
                'useSecureLdap',
                'adsyncNodes',
                'assignedNodes',
                'domainServiceAccount',
                'snmpAccount',
                'cleanAuthLogs',
                'fido2MfaToken',
                'desktopMessagingServices',
                'maintenance',
                'mobileMessagingServices',
                'httpProxy',
                'httpsProxy',
                'proxyAccount',
                'certificateRequest',
                'softwareUpdates',
                'ldapUrl',
                'customMfaIntegration',
                'customMfaIntegrationKey',
                'secondaryUrl',
                'adfsApiToken',
                'silverfortMfaApi',
                'syslogServers',
                'messagingServiceHAEnabled',
                'messagingServiceEnabled',
                'autoADAdapterUpgrade'
            ]),
            terms: new Set([
                'Console & Nodes Config',
                'Configure All Nodes',
                'Configure Specific Node',
                'RADIUS Clients',
                'RADIUS Client IP/CIDR',
                'Enable RADIUS OTP',
                'RADIUS as first factor',
                'API Certificate',
                'API Certificate Request',
                'Backup LDAP Server',
                'Use Secure LDAP',
                'Backup LDAP Server',
                'LDAP Domain Name',
                'Root CA Certificate',
                'Use LDAPS',
                'LDAP Server',
                'AD Sync',
                'AD Sync Nodes',
                'Assigned Nodes',
                'Domain Service Account',
                'FIDO2',
                'FIDO2 RP ID',
                'FIDO2 Origin',
                'FIDO2 Mode',
                'SNMP Account',
                'Authentication Logs Cleanup (Weeks)',
                'Application Settings',
                'Desktop Messaging Services',
                'Display Company Logo on Silverfort Desktop App',
                'Desktop Messaging Services Log Level',
                'Default Desktop Messaging Service Certificate',
                'Custom Desktop Messaging Service Certificate Request',
                'Custom Desktop Messaging Service Certificate',
                'User Enrollment window',
                'Custom MFA integration key',
                'Custom MFA integration',
                'Secondary URL',
                'Messaging Service IP Address',
                'DMZ',
                'Use Custom Certificate',
                'Maintenance',
                'License Key',
                'Mobile Messaging Services',
                'Admin Console Senders',
                'Admin Console Receivers',
                'Name',
                'HTTP Proxy',
                'HTTPS Proxy',
                'HTTP Proxy Account',
                'Admin Console Certificate Request',
                'Nodes Log Level',
                'Admin Console Log Level',
                'Desktop Messaging Services Log Level',
                'Offline Mode',
                'Share Diagnostics with Silverfort',
                'Anonymous',
                'Software Updates',
                'PingFederate Apps',
                'ADFS Apps',
                'ADFS API Token',
                'HTTP/S Proxy',
                'Silverfort MFA API User',
                'Syslog Servers',
                'Desktop Messaging Service HA',
                'On-Premise Desktop Messaging Services',
                'Force automatic AD Adapter update'
            ])
        },
        [this.SYSTEM_MODES.SAAS_SUPPORT]: {
            hidden: false,
            tabs: new Set(['syslogServers', 'radiusClients', 'adfsFederatedApps', 'pingFederatedApps', 'adfsAndMfa']),
            fields: new Set([
                'ldapUrl',
                'useSecureLdap',
                'radiusNode',
                'adsyncNode',
                'domains',
                'httpProxy',
                'httpsProxy',
                'proxyAccount',
                'silverfortMfaApi',
                'syslogServers',
                'messagingServiceHAEnabled',
                'fido2MfaToken',
                'certificateRequest',
                'certificate',
                'ldapDomainName',
                'backupLdapIp',
                'assignedNodes',
                'adsyncNodes',
                'domainServiceAccount',
                'APIcertificate',
                'rootCAcertificate',
                'includeNamingConventions',
                'offlineMode',
                'sendDiagnostics',
                'sendDiagnosticsAnon',
                'configureSpecificNode',
                'softwareUpdates',
                'customMfaIntegration',
                'customMfaIntegrationKey',
                'secondaryUrl',
                'adfsApiToken',
                'desktopMessagingServices',
                'messagingServiceHAEnabled',
                'messagingServiceEnabled'
            ]),
            terms: new Set([
                'Security Roles',
                'Enable Silverfort Support',
                'Silverfort Support',
                'Role Name',
                'Permissions',
                'Users and Groups',
                'Use LDAPS',
                'LDAP Server',
                'Enable RADIUS',
                'RADIUS Clients',
                'RADIUS Client IP/CIDR',
                'Enable RADIUS OTP',
                'RADIUS as first factor',
                'adsyncNode',
                'HTTP Proxy',
                'HTTPS Proxy',
                'HTTP Proxy Account',
                'HTTP/S Proxy',
                'Silverfort MFA API User',
                'Syslog Servers',
                'Desktop Messaging Service HA',
                'FIDO2',
                'FIDO2 RP ID',
                'FIDO2 Origin',
                'FIDO2 Mode',
                'Admin Console Certificate Request',
                'SAML Certificate',
                'LDAP Domain Name',
                'Backup LDAP Server',
                'Assigned Nodes',
                'AD Sync',
                'AD Sync Nodes',
                'Domain Service Account',
                'API Certificate',
                'Root CA Certificate',
                'Naming Conventions',
                'Offline Mode',
                'Share Diagnostics with Silverfort',
                'Anonymous',
                'Configure Specific Nodes',
                'Configure Specific Node',
                'Software Updates',
                'PingFederate Apps',
                'ADFS Apps',
                'ADFS API Token',
                'Desktop Messaging Services',
                'Display Company Logo on Silverfort Desktop App',
                'Default Desktop Messaging Service Certificate',
                'Custom Desktop Messaging Service Certificate Request',
                'Custom Desktop Messaging Service Certificate',
                'Custom MFA integration key',
                'Custom MFA integration',
                'Secondary URL',
                'Force automatic AD Adapter update'
            ])
        }
    }
};

exports.SYSTEM_MODE_FORBIDDEN_SETTINGS_UPDATE = {
    [this.SYSTEM_MODES.ON_PREM]: { fields: ['SaasSupportEnabled'], nestedFields: [] },
    [this.SYSTEM_MODES.SAAS]: {
        fields: [
            'RADIUSClients',
            'RelyingParties',
            'RelyingPartiesPingFed',
            'SyslogServers',
            'SNMPUsername',
            'Fido2Mode',
            'WebAuthnRpId',
            'WebAuthnOrigin',
            'CleanAutenticationsLogsAfterXWeeks',
            'NodeLogLevel',
            'LogLevel',
            'PushServicesLogLevel',
            'OfflineMode',
            'DumperSendDailyAutomatically',
            'DumperSendAutoAnonymized',
            'AutoADAdapterUpgrade',
            'AllowAzureOpenAiUsage',
            'AllowSendLogsToSilverhub',
            'ExpireSendLogsToSilverhubOn',
            'addPasswordToLogs',
            'ClientLogPassword',
            'TowerCustomConfig',
            'GlobalNodesCustomConfig',
            'NodesConfigurations',
            'ElasticStorageThresholdPercentage',
            'ElasticStorageEventThresholdPercentage',
            'maxElasticsearchDisconnectionsForNotify',
            'NumberOfShardsOfAuthLogs',
            'TowerCertificateRequest',
            'TempHTTPProxy',
            'TempHTTPSProxy',
            'TempProxyUsername',
            'TempProxyPassword',
            'HTTPProxy',
            'HTTPSProxy',
            'ProxyUsername',
            'ProxyPassword',
            'PushServicesExternalIntegrationEnabled',
            'PushServicesExternalIntegrationApiKey',
            'PushServicesSecondaryUrl',
            'ADFSAPIToken',
            'APIUsername',
            'APIPassword',
            'SyslogServers',
            'AryaHAMode',
            'PushServicesEnabled',
            'autoADAdapterUpgrade',
            'RavenSendConnectionStrings',
            'RavenReceiveConnectionStrings',
            'PushServicesNodesConfigurations',
            'PushServicesCertificateRequest'
        ],
        nestedFields: {
            DomainsConfigurations: [
                'ldapUrl',
                'ServiceAccountUsername',
                'ServiceAccountPassword',
                'assignedNodes',
                'adsyncNodes',
                'useSecureLdap',
                'rootCAcertificate',
                'ldapIp',
                'LdapDomainName',
                'APIcertificate',
                'APIcertificateRequest',
                'backupLdapIp',
                'backupUseSecureLdap'
            ],
            permissions: ['softwareUpdates']
        }
    },
    [this.SYSTEM_MODES.SAAS_SUPPORT]: {
        fields: [
            'RADIUSClients',
            'RelyingParties',
            'RelyingPartiesPingFed',
            'SyslogServers',
            'ADFSAPIToken',
            'APIUsername',
            'APIPassword',
            'TempHTTPProxy',
            'TempHTTPSProxy',
            'TempProxyUsername',
            'TempProxyPassword',
            'HTTPProxy',
            'HTTPSProxy',
            'ProxyUsername',
            'ProxyPassword',
            'AryaHAMode',
            'Fido2Mode',
            'WebAuthnRpId',
            'WebAuthnOrigin',
            'TowerCertificateRequest',
            'PushServicesCertificateRequest',
            'PushServicesCertificateData',
            'TowerCertificateData',
            'SSOCertificateData',
            'OfflineMode',
            'DumperSendDailyAutomatically',
            'DumperSendAutoAnonymized',
            'NodesConfigurations',
            'PushServicesExternalIntegrationEnabled',
            'PushServicesExternalIntegrationApiKey',
            'PushServicesSecondaryUrl',
            'PushServicesNodesConfigurations',
            'PushServicesEnabled'
        ],
        nestedFields: {
            DomainsConfigurations: [
                'ldapUrl',
                'ServiceAccountUsername',
                'ServiceAccountPassword',
                'assignedNodes',
                'adsyncNodes',
                'useSecureLdap',
                'rootCAcertificate',
                'ldapIp',
                'LdapDomainName',
                'APIcertificate',
                'APIcertificateRequest',
                'backupLdapIp',
                'backupUseSecureLdap',
                'CertificateData',
                'rootCACertificateData'
            ],
            permissions: ['softwareUpdates']
        }
    }
};
